var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatorHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12 15.77 11.23 17.37 10 18.46C8.94 19.42 7.54 20 6 20C2.69 20 0 17.31 0 14C0 11.916 1.07431 10.0764 2.69234 9.00386C2.87218 8.88465 3.1108 8.96917 3.20169 9.16485C4.12763 11.1584 5.90083 12.6555 8.02 13.23C8.65 13.41 9.31 13.5 10 13.5C10.5428 13.5 11.0601 13.4427 11.5621 13.3382C11.7663 13.2957 11.9702 13.4272 11.9861 13.6352C11.9954 13.7569 12 13.8796 12 14Z",
    fill: "#564ECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 6.78 15.85 7.53 15.58 8.21C14.89 9.95 13.41 11.29 11.58 11.79C11.08 11.93 10.55 12 10 12C9.45 12 8.92 11.93 8.42 11.79C6.59 11.29 5.11 9.95 4.42 8.21C4.15 7.53 4 6.78 4 6C4 2.69 6.69 0 10 0C13.31 0 16 2.69 16 6Z",
    fill: "#564ECE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14C20 17.31 17.31 20 14 20C13.1849 20 12.4036 19.8373 11.6953 19.5398C11.4718 19.4459 11.4299 19.1561 11.5926 18.9764C12.8178 17.6234 13.5 15.8538 13.5 14C13.5 13.66 13.47 13.32 13.42 13L13.4116 12.9479C13.3868 12.7945 13.4651 12.6435 13.6015 12.5692C14.9948 11.8107 16.1236 10.622 16.7985 9.16549C16.8893 8.96957 17.1281 8.88481 17.3081 9.00414C18.9259 10.0767 20 11.9161 20 14Z",
    fill: "#564ECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorHub);
export default __webpack_public_path__ + "static/media/CreatorHub.f33dd2f7dc07c40c0907ff6f064253b7.svg";
export { ForwardRef as ReactComponent };